/**
 * MODULE: _shared/frontend-shell/src/features/crm/api/crmDealStageHistoryApi.ts
 * PURPOSE: GET /api/v1/crm/deals/{id}/stage-history (dashboard-service)
 * DEPENDENCIES: @shared/lib/frontend/api/config
 * PUBLIC_API: fetchDealStageHistory
 * SIDE_EFFECTS: HTTP fetch
 * AGENT_SAFETY: SAFE
 */

import { API_CONFIG, getAuthHeaders } from '@shared/lib/frontend/api/config';
import type { StageHistoryEntry } from '../types/crm.types';

type HistoryJson = {
  history?: Array<{
    stage?: string;
    changedAt?: string;
    changedBy?: string;
    changedByName?: string;
    daysInStage?: number | null;
  }>;
};

export async function fetchDealStageHistory(dealId: string): Promise<StageHistoryEntry[]> {
  const url = `${API_CONFIG.baseURL}/api/v1/crm/deals/${encodeURIComponent(dealId)}/stage-history`;
  const res = await fetch(url, { headers: getAuthHeaders() });
  if (!res.ok) throw new Error(await res.text());
  const body = (await res.json()) as HistoryJson;
  const raw = Array.isArray(body.history) ? body.history : [];
  return raw.map((r) => ({
    stage: String(r.stage ?? 'prospecting') as StageHistoryEntry['stage'],
    changedAt: String(r.changedAt ?? new Date().toISOString()),
    changedBy: String(r.changedBy ?? ''),
    changedByName: String(r.changedByName ?? ''),
    daysInStage: r.daysInStage === null || r.daysInStage === undefined ? undefined : Number(r.daysInStage),
  }));
}
